/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamMemberRole = "Admin" | "Member" | "%future added value";
export type FeedSchedulerInput_viewer = {
    readonly personQueryResultErrorable?: {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        readonly __typename: "PersonQueryResult";
        readonly query: string;
        readonly persons: ReadonlyArray<{
            readonly id: string;
            readonly primaryEmail: string;
            readonly emails: ReadonlyArray<string>;
            readonly profile: {
                readonly givenName: string | null;
                readonly familyName: string | null;
                readonly externalImageUrl: string | null;
            } | null;
        } | null>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    } | undefined;
    readonly groupQueryResult?: {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        readonly __typename: "ExternalGroupSearchResult";
        readonly inputQuery: string;
        readonly groups: ReadonlyArray<{
            readonly emailAddress: string;
            readonly groupSize: number;
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    } | undefined;
    readonly teamQueryResultErrorable?: {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        readonly __typename: "TeamQueryResult";
        readonly query: string;
        readonly teams: ReadonlyArray<{
            readonly teamName: string;
            readonly teamId: string;
            readonly teamRoleAndPersonIds: ReadonlyArray<{
                readonly role: TeamMemberRole;
                readonly personId: string;
            }>;
        }>;
        readonly teamMembers: ReadonlyArray<{
            readonly role: TeamMemberRole;
            readonly person: {
                readonly personId: string;
                readonly isYou: boolean;
                readonly primaryCalendarId: string;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
            };
        }>;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    } | undefined;
    readonly " $refType": "FeedSchedulerInput_viewer";
};
export type FeedSchedulerInput_viewer$data = FeedSchedulerInput_viewer;
export type FeedSchedulerInput_viewer$key = {
    readonly " $data"?: FeedSchedulerInput_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FeedSchedulerInput_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v1 = {
        "kind": "Variable",
        "name": "query",
        "variableName": "queryInput"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "excludeCalendars",
            "variableName": "excludeCalendars"
        } as any,
        (v0 /*: any*/),
        (v1 /*: any*/)
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "query",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "excludeCalendars"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "externalGroupRefetch"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgRelayId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "queryInput"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "FeedSchedulerInput_viewer",
        "selections": [
            {
                "condition": "externalGroupRefetch",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "alias": null,
                        "args": (v2 /*: any*/),
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "personQueryResultErrorable",
                        "plural": false,
                        "selections": [
                            (v3 /*: any*/),
                            (v4 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v5 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "persons",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "id",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "primaryEmail",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "emails",
                                                "storageKey": null
                                            },
                                            (v6 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "type": "PersonQueryResult",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": (v2 /*: any*/),
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "groupQueryResult",
                        "plural": false,
                        "selections": [
                            (v3 /*: any*/),
                            (v4 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "inputQuery",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ExternalGroupSearchMetadata",
                                        "kind": "LinkedField",
                                        "name": "groups",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "emailAddress",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "groupSize",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "type": "ExternalGroupSearchResult",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": [
                            (v0 /*: any*/),
                            (v1 /*: any*/)
                        ],
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "teamQueryResultErrorable",
                        "plural": false,
                        "selections": [
                            (v3 /*: any*/),
                            (v4 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v5 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Team",
                                        "kind": "LinkedField",
                                        "name": "teams",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "teamName",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "teamId",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TeamRoleAndPersonId",
                                                "kind": "LinkedField",
                                                "name": "teamRoleAndPersonIds",
                                                "plural": true,
                                                "selections": [
                                                    (v7 /*: any*/),
                                                    (v8 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TeamMember",
                                        "kind": "LinkedField",
                                        "name": "teamMembers",
                                        "plural": true,
                                        "selections": [
                                            (v7 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OrgPerson",
                                                "kind": "LinkedField",
                                                "name": "person",
                                                "plural": false,
                                                "selections": [
                                                    (v8 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "isYou",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "primaryCalendarId",
                                                        "storageKey": null
                                                    },
                                                    (v6 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "type": "TeamQueryResult",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ]
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'dee138b2562dd42e76416e2bb2f7436a';
export default node;
